"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PICK_YOUR_PLAN_COPY = void 0;
/**
 * AN-30 (Anthony's batch, 9 Oct; web and mobile, rule 17, agreed 2026-10-12): the plan
 * picker's title INSIDE the sign-up flow, on both apps. Outside it the page keeps its
 * "Payment & Subscription" title.
 */
exports.PICK_YOUR_PLAN_COPY = "Pick your plan";
//# sourceMappingURL=planPickerCopy.js.map